<template>
  <app-page lean>
    <!-- leichter Titel wie die übrigen Seiten (Kundenwunsch 13.10.2026: „jetzt noch profil und kundeneinstellungen
         anpassen“); das Formular als verschachtelte Karte wie im Dashboard, „Speichern“ im Fuß der inneren Karte -->
    <div class="app-page-pad">
      <app-panel nested icon="briefcase" title="Kundendaten" flush class="customer-panel">
        <div class="app-form customer-form">
          <div class="app-form-field">
            <label class="app-label" for="customer-printname">Firmenname</label>
            <app-text-field id="customer-printname" v-model="cust_printname" />
          </div>
          <div class="app-form-field">
            <label class="app-label" for="customer-url">Website</label>
            <app-text-field id="customer-url" v-model="customer_url" />
          </div>
          <div class="app-form-field">
            <label class="app-label" for="customer-tel">Telefon</label>
            <app-text-field id="customer-tel" v-model="customer_tel" />
          </div>
          <div class="customer-form__row">
            <div class="app-form-field">
              <label class="app-label" for="customer-filter">Haltestellen Autocomplete Filter</label>
              <app-text-field id="customer-filter" v-model="global_location_filter" />
            </div>
            <div class="app-form-field">
              <label class="app-label" for="customer-suggestions">Vorschläge</label>
              <app-select
                id="customer-suggestions"
                v-model="select"
                :items="suggestionItems"
                placeholder="Bundesland wählen"
                block
              />
            </div>
          </div>
        </div>
        <div class="customer-foot">
          <app-button kind="primary" icon="check" :loading="loading" @click="save()">Speichern</app-button>
        </div>
      </app-panel>
    </div>
  </app-page>
</template>

<script>
import { mapState } from "vuex";
import axios from "axios";

export default {
  data() {
    return {
      loading: false,
      customer: {},
      cust_printname: null,
      customer_url: null,
      customer_tel: null,
      global_location_filter: null,
      items: [
        { label: "Schleswig-Holstein", filter: "de:01" },
        { label: "Hansestadt Hamburg", filter: "de:02" },
        { label: "Niedersachsen", filter: "de:03" },
        { label: "Hansestadt Bremen", filter: "de:04" },
        { label: "Nordrhein-Westfalen", filter: "de:05" },
        { label: "Hessen", filter: "de:06" },
        { label: "Rheinland-Pfalz", filter: "de:07" },
        { label: "Baden-Württemberg", filter: "de:08" },
        { label: "Freistaat Bayern", filter: "de:09" },
        { label: "Saarland", filter: "de:10" },
        { label: "Berlin", filter: "de:11" },
        { label: "Brandenburg", filter: "de:12" },
        { label: "Mecklenburg-Vorpommern", filter: "de:13" },
        { label: "Freistaat Sachsen", filter: "de:14" },
        { label: "Sachsen-Anhalt", filter: "de:15" },
        { label: "Freistaat Thüringen", filter: "de:16" }
      ],
      select: null
    };
  },
  computed: {
    ...mapState(["profile"]),
    // Einträge der Vorschläge-Auswahl wie bisher: Text „Bundesland (de:NN)“, Wert = Filter
    suggestionItems() {
      return this.items.map(item => ({
        value: item.filter,
        text: `${item.label} (${item.filter})`
      }));
    },
  },
   watch: {
    select: function (val) {
      this.global_location_filter = val;
    }
  },
  methods: {
    async save() {
      this.loading = true;
      await axios.put(`${this.$store.state.baseUrl}customer`, {
        cust_printname: this.cust_printname,
        customer_url: this.customer_url,
        customer_tel: this.customer_tel,
        global_location_filter: this.global_location_filter,
      });
      this.customer = (
        await axios.get(`${this.$store.state.baseUrl}customer`)
      ).data;
      this.$store.commit("setCustomer", this.customer);
      this.loading = false;
    },
  },
  async mounted() {
    this.customer = (
      await axios.get(`${this.$store.state.baseUrl}customer`)
    ).data;
    this.$store.commit("setCustomer", this.customer);
    this.cust_printname = this.customer.cust_printname;
    this.customer_url = this.customer.customer_url;
    this.customer_tel = this.customer.customer_tel;
    this.global_location_filter = this.customer.global_location_filter;
  },
};
</script>

<style scoped>
.customer-panel {
  max-width: 640px;
}
.customer-form {
  padding: var(--sp-4);
}
/* Filter und Vorschläge nebeneinander, bei wenig Breite untereinander */
.customer-form__row {
  display: flex;
  flex-wrap: wrap;
  gap: var(--sp-4);
}
.customer-form__row > .app-form-field {
  flex: 1 1 220px;
}
/* Fuß der inneren Karte wie im Detailbereich: rechtsbündig über einer Linie, unten gerundet wie die Karte */
.customer-foot {
  border-radius: 0 0 var(--r-nest-in) var(--r-nest-in);
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: var(--sp-2);
  min-height: var(--h-foot);
  box-sizing: border-box;
  padding: var(--sp-1) var(--sp-4);
  border-top: 1px solid var(--line);
  background: var(--band);
}
@media (max-width: 599.98px) {
  .customer-form {
    padding: var(--sp-3);
  }
}
</style>
